import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import usePageTitle from '../hooks/usePageTitle';
import './StaticHtmlPage.css';

function StaticHtmlPage({ title, htmlPath }) {
  const [html, setHtml] = useState('');
  usePageTitle(title);

  useEffect(() => {
    // Carga el HTML vía fetch y lo sanitiza con DOMPurify antes de inyectarlo
    fetch(htmlPath)
      .then((res) => res.text())
      .then((rawHtml) => {
        const clean = DOMPurify.sanitize(rawHtml, {
          USE_PROFILES: { html: true },
        });
        setHtml(clean);
      })
      .catch(() => setHtml('<p>Error cargando el contenido.</p>'));
  }, [htmlPath]);

  return (
    <div className="static-page">
      <div className="static-hero">
        <div className="static-hero-content">
          <h1>{title}</h1>
          <p>Consulta la información completa a continuación</p>
        </div>
      </div>

      <div className="container">
        <div className="static-card">
          <div
            className="static-html"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      </div>
    </div>
  );
}

export default StaticHtmlPage;